"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnChangePlugin = OnChangePlugin;
var _LexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _html = require("@lexical/html");
var _lexical = require("lexical");
var _react = require("react");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // When the editor changes, you can get notified via the
// OnChangePlugin!
function OnChangePlugin(_ref) {
  var onChange = _ref.onChange;
  // Access the editor through the LexicalComposerContext
  var _useLexicalComposerCo = (0, _LexicalComposerContext.useLexicalComposerContext)(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  // Wrap our listener in useEffect to handle the teardown and avoid stale references.
  var first = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    // most listeners return a teardown function that can be called to clean them up.
    return editor.registerUpdateListener(function (_ref2) {
      var editorState = _ref2.editorState;
      // call onChange here to pass the latest state up to the parent.
      editor.update(function () {
        if (first.current) {
          first.current = false;
        } else {
          var _root$getFirstChild;
          var root = (0, _lexical.$getRoot)();
          var isEmpty =
          // @ts-ignore
          ((_root$getFirstChild = root.getFirstChild()) === null || _root$getFirstChild === void 0 ? void 0 : _root$getFirstChild.isEmpty()) && root.getChildrenSize() === 1;
          onChange(editorState, isEmpty ? null : (0, _html.$generateHtmlFromNodes)(editor));
        }
      });
    });
  }, [editor, onChange]);
  return null;
}